import { render, staticRenderFns } from "./v-dalog.vue?vue&type=template&id=3517cba5&scoped=true&"
import script from "./v-dalog.vue?vue&type=script&lang=js&"
export * from "./v-dalog.vue?vue&type=script&lang=js&"
import style0 from "./v-dalog.vue?vue&type=style&index=0&id=3517cba5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3517cba5",
  null
  
)

export default component.exports